import { render, staticRenderFns } from "./activityDetail.vue?vue&type=template&id=794180b3&scoped=true&"
import script from "./activityDetail.vue?vue&type=script&lang=ts&"
export * from "./activityDetail.vue?vue&type=script&lang=ts&"
import style0 from "./activityDetail.vue?vue&type=style&index=0&id=794180b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794180b3",
  null
  
)

export default component.exports